import { Box, Button } from "@chakra-ui/react";
import "./pagination.css";

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    if (currentPage > 3) {
      pageNumbers.push(
        <Button
          key="first"
          onClick={() => handlePageChange(1)}
          mx="1"
          color="#000"
          border="1px solid #BEBEBE"
          bg={currentPage === 1 ? "#000" : "transparent"}
          _hover={{ bg: currentPage === 1 ? "#000" : "#e0e0e0" }}
        >
          1
        </Button>
      );
      if (currentPage > 4) {
        pageNumbers.push(<span key="dots1">...</span>);
      }
    }

    for (let page = startPage; page <= endPage; page++) {
      pageNumbers.push(
        <Button
          key={page}
          onClick={() => handlePageChange(page)}
          mx="1"
          color={currentPage === page ? "#fff" : "#000"}
          border="1px solid #BEBEBE"
          bg={currentPage === page ? "#000" : "transparent"}
          _hover={{ bg: currentPage === page ? "#000" : "#e0e0e0" }}
        >
          {page}
        </Button>
      );
    }

    if (currentPage < totalPages - 2) {
      if (currentPage < totalPages - 3) {
        pageNumbers.push(<span key="dots2">...</span>);
      }

      pageNumbers.push(
        <Button
          key={totalPages}
          onClick={() => handlePageChange(totalPages)}
          mx="1"
          color="#000"
          border="1px solid #BEBEBE"
          bg={currentPage === totalPages ? "#000" : "transparent"}
          _hover={{ bg: currentPage === totalPages ? "#000" : "#e0e0e0" }}
        >
          {totalPages}
        </Button>
      );
    }

    return pageNumbers;
  };

  return (
    <Box display="flex" justifyContent="center" mt="4">
      {renderPageNumbers()}
    </Box>
  );
};

export default Pagination;